export default __webpack_public_path__ + "static/media/icon_search.809201fb.svg";